/* ══════════════════════════════════════════════════════════
   CHARISMA COSMETICS — Main Product Section JS
   File: section-main-product.js
   VERSION: 5.1 — Double-add bug fixed
   ✅ Pack discount properties cart mein jaati hain
   ✅ Quantity = userQty × packMultiplier
   ✅ Buy Now — sirf same product 2+ qty pe discount code pass hoga
   ✅ Double-click ATC bug fixed (_atcLocked guard)
══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var _atcLocked = false;

  function formatMoney(cents) {
    return 'Rs.' + (cents / 100).toLocaleString('en-PK', { minimumFractionDigits: 0 });
  }

  function el(id) { return document.getElementById(id); }

  /* ══════════════════════════════════════════════════════
     PRODUCT PAGE — initSection
  ══════════════════════════════════════════════════════ */
  function initSection(sectionId, variantPriceInit, variants) {
    var sid = sectionId;

    var mainWrap     = el('cp-main-wrap-'     + sid);
    var dotsEl       = el('cp-dots-'          + sid);
    var arrowsEl     = el('cp-arrows-'        + sid);
    var thumbsEl     = el('cp-thumbs-'        + sid);
    var priceEl      = el('cp-price-'         + sid);
    var subtotalEl   = el('cp-subtotal-'      + sid);
    var qtyInput     = el('cp-qty-'           + sid);
    var qtyHidden    = el('cp-qty-hidden-'    + sid);
    var variantIdEl  = el('cp-variant-id-'    + sid);
    var packSelector = el('cp-pack-selector-' + sid);
    var qtyMinus     = el('cp-qty-minus-'     + sid);
    var qtyPlus      = el('cp-qty-plus-'      + sid);

    if (!mainWrap) return;

    var variantPrice           = variantPriceInit;
    var selectedPackMultiplier = 1;
    var selectedPackDiscount   = 0;
    var autoSlideTimer         = null;
    var AUTO_SLIDE_DELAY       = 3000;

    /* ══ IMAGE SLIDER ══ */
    var slides  = mainWrap.querySelectorAll('.cp-slide');
    var dots    = dotsEl   ? dotsEl.querySelectorAll('.cp-dot')     : [];
    var thumbs  = thumbsEl ? thumbsEl.querySelectorAll('.cp-thumb') : [];
    var current = 0;
    var total   = slides.length;

    function goTo(idx) {
      if (total <= 1) return;
      slides[current].classList.remove('active');
      if (dots[current])   dots[current].classList.remove('active');
      if (thumbs[current]) thumbs[current].classList.remove('active');
      current = (idx + total) % total;
      slides[current].classList.add('active');
      if (dots[current])   dots[current].classList.add('active');
      if (thumbs[current]) thumbs[current].classList.add('active');
    }

    function startAutoSlide() {
      if (total <= 1) return;
      stopAutoSlide();
      autoSlideTimer = setInterval(function () { goTo(current + 1); }, AUTO_SLIDE_DELAY);
    }

    function stopAutoSlide() {
      if (autoSlideTimer) { clearInterval(autoSlideTimer); autoSlideTimer = null; }
    }

    mainWrap.addEventListener('mouseenter', stopAutoSlide);
    mainWrap.addEventListener('mouseleave', startAutoSlide);

    if (arrowsEl) {
      arrowsEl.querySelector('.cp-arrow-prev').addEventListener('click', function () {
        stopAutoSlide(); goTo(current - 1); startAutoSlide();
      });
      arrowsEl.querySelector('.cp-arrow-next').addEventListener('click', function () {
        stopAutoSlide(); goTo(current + 1); startAutoSlide();
      });
    }

    Array.prototype.forEach.call(dots, function (dot) {
      dot.addEventListener('click', function () {
        stopAutoSlide(); goTo(parseInt(this.dataset.index, 10)); startAutoSlide();
      });
    });

    Array.prototype.forEach.call(thumbs, function (thumb) {
      thumb.addEventListener('click', function () {
        stopAutoSlide(); goTo(parseInt(this.dataset.index, 10)); startAutoSlide();
      });
    });

    var touchStartX = 0;
    mainWrap.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX; stopAutoSlide();
    }, { passive: true });
    mainWrap.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
      startAutoSlide();
    }, { passive: true });

    startAutoSlide();

    /* ══ QUANTITY ══ */
    function getQty() {
      return Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1);
    }

    function updateSubtotal() {
      var userQty    = getQty();
      var totalUnits = userQty * selectedPackMultiplier;
      var rawTotal   = variantPrice * totalUnits;
      var discounted = selectedPackDiscount > 0
        ? Math.round(rawTotal * (100 - selectedPackDiscount) / 100)
        : rawTotal;

      if (qtyHidden)  qtyHidden.value       = userQty;
      if (subtotalEl) subtotalEl.textContent = formatMoney(discounted);
    }

    if (qtyMinus) {
      qtyMinus.addEventListener('click', function () {
        var q = getQty(); if (q > 1) { qtyInput.value = q - 1; updateSubtotal(); }
      });
    }
    if (qtyPlus) {
      qtyPlus.addEventListener('click', function () {
        qtyInput.value = getQty() + 1; updateSubtotal();
      });
    }
    if (qtyInput) qtyInput.addEventListener('input', updateSubtotal);

    /* ══ PACK SELECTOR ══ */
    if (packSelector) {
      var packCards = packSelector.querySelectorAll('.cp-pack-card');
      Array.prototype.forEach.call(packCards, function (card) {
        card.addEventListener('click', function () {
          Array.prototype.forEach.call(packCards, function (c) {
            c.classList.remove('active');
            c.setAttribute('aria-pressed', 'false');
          });
          card.classList.add('active');
          card.setAttribute('aria-pressed', 'true');
          selectedPackMultiplier = parseInt(card.dataset.multiplier, 10) || 1;
          selectedPackDiscount   = parseInt(card.dataset.discount,   10) || 0;
          updateSubtotal();
        });
      });
    }

    /* ══ VARIANT PILLS ══ */
    var pills = document.querySelectorAll('#MainProduct-' + sid + ' [data-option-index]');
    Array.prototype.forEach.call(pills, function (pill) {
      pill.addEventListener('click', function () {
        var siblings = this.closest('.cp-option-values').querySelectorAll('.cp-option-pill');
        Array.prototype.forEach.call(siblings, function (p) { p.classList.remove('selected'); });
        this.classList.add('selected');
        matchVariant();
      });
    });

    function matchVariant() {
      var selected = [];
      var groups = document.querySelectorAll('#MainProduct-' + sid + ' .cp-option-group');
      Array.prototype.forEach.call(groups, function (grp) {
        var active = grp.querySelector('.cp-option-pill.selected');
        if (active) selected.push(active.dataset.value);
      });
      Array.prototype.forEach.call(variants, function (v) {
        var match = v.options.every(function (opt, i) { return opt === selected[i]; });
        if (!match) return;
        variantPrice = v.price;
        if (variantIdEl) variantIdEl.value = v.id;
        resetPackToOne();
        updateSubtotal();
        updatePriceDisplay(v);
        updatePackPrices(v.price);
        updateAtcButton(v.available);
      });
    }

    function resetPackToOne() {
      if (!packSelector) return;
      var cards = packSelector.querySelectorAll('.cp-pack-card');
      Array.prototype.forEach.call(cards, function (c) {
        c.classList.remove('active'); c.setAttribute('aria-pressed', 'false');
      });
      var first = cards[0];
      if (first) {
        first.classList.add('active');
        first.setAttribute('aria-pressed', 'true');
        selectedPackMultiplier = 1;
        selectedPackDiscount   = 0;
      }
    }

    /* ══ PRICE DISPLAY ══ */
    function updatePriceDisplay(v) {
      if (!priceEl) return;
      var priceSpan   = priceEl.querySelector('.cp-price');
      var compareSpan = priceEl.querySelector('.cp-compare');
      var badgeSpan   = priceEl.querySelector('.cp-badge');
      if (priceSpan) priceSpan.textContent = formatMoney(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        var savings = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        if (!compareSpan) {
          compareSpan = document.createElement('span');
          compareSpan.className = 'cp-compare';
          priceEl.appendChild(compareSpan);
        }
        compareSpan.textContent = formatMoney(v.compare_at_price);
        compareSpan.style.display = '';
        if (!badgeSpan) {
          badgeSpan = document.createElement('span');
          badgeSpan.className = 'cp-badge';
          priceEl.appendChild(badgeSpan);
        }
        badgeSpan.textContent = savings + '% OFF';
        badgeSpan.style.display = '';
      } else {
        if (compareSpan) compareSpan.style.display = 'none';
        if (badgeSpan)   badgeSpan.style.display   = 'none';
      }
    }

    /* ══ PACK PRICES ══ */
    function updatePackPrices(basePrice) {
      if (!packSelector) return;
      Array.prototype.forEach.call(packSelector.querySelectorAll('.cp-pack-card'), function (card) {
        var mult      = parseInt(card.dataset.multiplier, 10) || 1;
        var disc      = parseInt(card.dataset.discount,   10) || 0;
        var original  = basePrice * mult;
        var sale      = disc > 0 ? Math.round(original * (100 - disc) / 100) : original;
        var singleEl  = card.querySelector('.cp-pack-price');
        var compareEl = card.querySelector('.cp-pack-compare');
        var saleEl    = card.querySelector('.cp-pack-sale');
        if (singleEl)  singleEl.textContent  = formatMoney(sale);
        if (compareEl) compareEl.textContent = formatMoney(original);
        if (saleEl)    saleEl.textContent    = formatMoney(sale);
      });
    }

    /* ══ ATC BUTTON ══ */
    function updateAtcButton(available) {
      var btn   = el('cp-atc-btn-'   + sid);
      var label = el('cp-atc-label-' + sid);
      if (!btn) return;
      btn.disabled = !available;
      if (label) {
        label.textContent = available
          ? (btn.dataset.labelIn  || 'Add to Cart')
          : (btn.dataset.labelOut || 'Sold Out');
      }
    }

    window['_cpPack_' + sid] = {
      getMultiplier: function () { return selectedPackMultiplier; },
      getDiscount:   function () { return selectedPackDiscount; },
      getPrice:      function () { return variantPrice; }
    };

    updateSubtotal();
  }

  /* ══════════════════════════════════════════════════════
     ADD TO CART — double-click guard added
  ══════════════════════════════════════════════════════ */
  function cpAddToCart(sectionId) {
    if (_atcLocked) return;
    _atcLocked = true;

    var sid       = sectionId;
    var btn       = el('cp-atc-btn-'    + sid);
    var label     = el('cp-atc-label-'  + sid);
    var variantEl = el('cp-variant-id-' + sid);
    var qtyInput  = el('cp-qty-'        + sid);
    if (!variantEl || !btn) { _atcLocked = false; return; }

    var packState  = window['_cpPack_' + sid] || {};
    var multiplier = packState.getMultiplier ? packState.getMultiplier() : 1;
    var discount   = packState.getDiscount   ? packState.getDiscount()   : 0;
    var basePrice  = packState.getPrice      ? packState.getPrice()      : 0;

    var userQty  = Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1);
    var totalQty = userQty * multiplier;
    var variantId = variantEl.value;
    var origText  = label ? label.textContent.trim() : 'Add to Cart';

    btn.disabled = true;
    if (label) label.textContent = 'Adding…';

    var properties = {};
    if (multiplier > 1) {
      properties['Pack'] = multiplier + ' Pack';
    }
    if (discount > 0) {
      properties['Discount']         = discount + '% OFF';
      properties['_discount_pct']    = String(discount);
      properties['_original_price']  = String(basePrice);
      properties['_pack_qty']        = String(totalQty);
    }

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity: totalQty, properties: properties })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          if (label) label.textContent = data.description || 'Error';
          setTimeout(function () { if (label) label.textContent = origText; btn.disabled = false; _atcLocked = false; }, 2000);
        } else {
          if (label) label.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:updated'));
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var badges = document.querySelectorAll('[data-cart-count], .cart-count-bubble span, #cart-icon-bubble span');
              Array.prototype.forEach.call(badges, function (b) { b.textContent = cart.item_count; });
            });
          setTimeout(function () { if (label) label.textContent = origText; btn.disabled = false; _atcLocked = false; }, 1500);
        }
      })
      .catch(function () {
        if (label) label.textContent = 'Error';
        setTimeout(function () { if (label) label.textContent = origText; btn.disabled = false; _atcLocked = false; }, 2000);
      });
  }

  /* ══════════════════════════════════════════════════════
     BUY NOW
     ✅ Sirf multiplier 2+ ho tab discount code pass karo
  ══════════════════════════════════════════════════════ */
  function cpBuyNow(sectionId, btn) {
    var sid       = sectionId;
    var variantEl = el('cp-variant-id-' + sid);
    var qtyInput  = el('cp-qty-'        + sid);
    if (!variantEl) return;

    var packState  = window['_cpPack_' + sid] || {};
    var multiplier = packState.getMultiplier ? packState.getMultiplier() : 1;
    var discount   = packState.getDiscount   ? packState.getDiscount()   : 0;
    var basePrice  = packState.getPrice      ? packState.getPrice()      : 0;

    var userQty  = Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1);
    var totalQty = userQty * multiplier;

    var properties = {};
    if (multiplier > 1) properties['Pack'] = multiplier + ' Pack';
    if (discount > 0) {
      properties['Discount']        = discount + '% OFF';
      properties['_discount_pct']   = String(discount);
      properties['_original_price'] = String(basePrice);
      properties['_pack_qty']       = String(totalQty);
    }

    if (btn) btn.disabled = true;

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body:    JSON.stringify({ id: variantEl.value, quantity: totalQty, properties: properties })
    })
      .then(function () {
        var discountCode = '';
        if (multiplier >= 3 && discount >= 10) discountCode = 'CHARISMA3';
        else if (multiplier >= 2 && discount >= 5) discountCode = 'CHARISMA2';

        var url = discountCode ? '/checkout?discount=' + discountCode : '/checkout';
        window.location.href = url;
      })
      .catch(function () {
        if (btn) btn.disabled = false;
      });
  }

  /* ── Expose globals ── */
  window.cpAddToCart   = cpAddToCart;
  window.cpBuyNow      = cpBuyNow;
  window.cpInitSection = initSection;

})();